module.exports = __webpack_public_path__ + "static/media/pdfIcon.ab209758.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pdfIcon.png
// module id = 978
// module chunks = 0